import React from "react";
import Link from "helpers/link";
import Image from "components/image";
import { useSelector } from "react-redux";
import { ReactComponent as Settings } from "assets/svgs/settings.svg";
import { useGlobalContext } from "context/global";
import { findClosestBox } from "utils/cart";
import { formatTitle } from "helpers/format-title";

const SubscriptionCockpit = ({ data }) => {
	const { translation, cartSettings } = useGlobalContext();
	const deliveryFrequencies = cartSettings.subscription.frequencies;
	const { status, deliveryPolicy, totalWeight, subscriptionId } = useSelector((state) => state.account.subscription);

	if (!subscriptionId || !deliveryFrequencies?.length) return null;

	const box = findClosestBox(cartSettings.boxes, totalWeight);

	const isActive = (intervalCount, interval) =>
		intervalCount === deliveryPolicy.intervalCount && interval === deliveryPolicy.interval;

	const renderContent = (tile) => {
		let desktopText, mobileText;
		const frequency = deliveryFrequencies?.find(s => isActive(s.intervalCount, s.interval));

		switch (tile.type) {
			case "size":
				desktopText = `${box?.size?.value}+ ${translation.cart?.meals} (${box?.price}/${translation.cart?.meal})`;
				mobileText = totalWeight > 0 && `${totalWeight} ${translation.cart?.meals}`;
				break;
			case "frequency":
				desktopText = frequency?.name;
				mobileText = `${frequency?.intervalCount} ${translation.shopping_flow?.weeks}`;
				break;
			default:
				desktopText = mobileText = status;
		}

		return (
			<>
				<p className="text-secondary px-4 text-lg md:block hidden">{desktopText}</p>
				<p className="text-xs px-2 md:hidden block">{mobileText}</p>
			</>
		);
	};

	return (
		<div className="mt-5 mb-10 md:mt-10 md:mb-20">
			<div className="text-center flex items-center flex-col">
				<div className="my-8 md:my-10 w-90 md:w-2/5 mx-auto">
					{data?.title && <h2>{formatTitle(data?.title)}</h2>}
					{data?.subtitle && <p>{data?.subtitle}</p>}
				</div>
				<div className="flex justify-center gap-2.5 md:gap-8 mx-4 md:mx-4 w-full">
					{data?.tiles?.length > 0 &&
						data?.tiles?.map((tile, index) => (
							<Link key={index} to={tile?.url} className="cockpit-container">
								<div className="relative pt-2 px-2 w-fit">
									<Image className="w-[25px] md:w-[35px]" image={tile?.icon} />
									{tile?.type === "size" && totalWeight > 0 && <div className="total-items">{totalWeight}</div>}
								</div>
								<p className="text-lg mt-4 md:block hidden">{formatTitle(tile?.title)}</p>
								{renderContent(tile)}
							</Link>
						))
					}
				</div>
				<Link to={data?.button?.url} className={`btn-${data?.button?.style} cockpit-button`}>
					<Settings className="mr-2" /> {data?.button?.text}</Link>
			</div>

		</div>
	);
};

export default SubscriptionCockpit;
